import React, { useState, useEffect } from 'react';
import { Search, Menu, ChevronRight } from 'lucide-react';
import './Details.scss';
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
import { getAmuAgentByHubById, DeleteAmuFromHubByIds, getUmappedAmuAgentByHubById,AddAmuFromHubByIds } from '../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import InfoIcon from '@mui/icons-material/Info';

const HubDashboard = ({ EditData, handlecurrentTab,handleData }) => {
    const [Data, setData] = useState({})
    const [activeTab, setActiveTab] = useState("mapped")
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        getAmuAgentByHubByIdFn()
    }, [])
    useEffect(() => {
        if (activeTab == "mapped") {
            getAmuAgentByHubByIdFn()
        } else if (activeTab == "Unmapped") {
            getUmappedAmuAgentByHubByIdFn()
        }
    }, [activeTab])

    const getAmuAgentByHubByIdFn = () => {
        setLoader(true)
        getAmuAgentByHubById(EditData?.hubId, callback => {
            setLoader(false)
            setData(callback?.data || {})
        })
    }
    const getUmappedAmuAgentByHubByIdFn = () => {
        setLoader(true)
        getUmappedAmuAgentByHubById(EditData?.hubId, callback => {
            setLoader(false)
            setData(callback?.data || {})
        })
    }

    const getPerformanceColor = (performance) => {
        if (performance >= 90) return 'high';
        if (performance >= 40) return 'medium';
        return 'low';
    };


    const handleSwitchChange = (data, isActive) => {

        setLoader(true)
        if(activeTab == "mapped"){

            DeleteAmuFromHubByIds(EditData?.hubId, data?.amuCommunityId, callBack => {
                setLoader(false)
                getAmuAgentByHubByIdFn()
            })
        }else if(activeTab == "Unmapped"){

            AddAmuFromHubByIds(EditData?.hubId, data?.amuCommunityId, callBack => {
                setLoader(false)
                getUmappedAmuAgentByHubByIdFn()
            })
        }
        
    }

    const handleInfoScreen =(data)=>{
       handleData(data)
        handlecurrentTab("AmuAgentDetail")
    }



    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="dashboard">
                <header className="dashboard-header">
                    <div className="header-left">
                        <div onClick={(e) => handlecurrentTab("main")} style={{ display: 'inline-flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                            <div>
                                <img src={BackLogo} alt="" width={'70%'} style={{ marginRight: '10px', cursor: 'pointer', flexShrink: '0' }} />
                            </div>
                            <div >
                                <h1 className="dashboard-title"  > {EditData?.hubName}</h1>
                                <p className="hub-subtitle" style={{ marginBottom: '0' }}>{EditData?.address}</p>
                            </div>
                        </div>
                    </div>
                    <div className="header-right">

                    </div>
                </header>

                <main className="dashboard-content">
                    <div className="agents-section">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 className="section-title">AMU Agents</h3>
                            <div className='btn-tabs-new-new'>
                                <button className={activeTab == "mapped" ? 'active' : ""} onClick={() => setActiveTab("mapped")}>Mapped</button>
                                <button className={activeTab == "Unmapped" ? 'active' : ""} onClick={() => setActiveTab("Unmapped")}>Unmapped</button>
                            </div>
                        </div>
                        <div className="row " style={{ marginTop: '25px' }}>
                            <div className="col-xs-12">
                                <div className="table-container">
                                    <table className="performance-table">
                                        <thead>
                                            <tr>
                                                <th>DETAILS</th>
                                                <th>AMU NAME</th>
                                                <th>EMAIL ID</th>
                                                <th>MOBILE NUMBER</th>
                                                {
                                                    activeTab == "mapped" ?
                                                        <>
                                                            <th>IS MANAGER</th>
                                                            <th>ADDED ON</th>
                                                        </>
                                                        : ""}
                                                <th>IS ACTIVE</th>
                                               
                                                <th className='text-center'>ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Data?.length > 0 && Data?.map((hub) => (
                                                <tr key={hub.id}>
                                                    <td className="hub-name text-center"><InfoIcon style={{cursor:'pointer'}} onClick={()=>handleInfoScreen(hub?.amuCommunityId)}/></td>
                                                    <td className="hub-name">{hub?.amuName || ""}</td>
                                                    <td className="state">{hub?.amuEmail || ""}</td>
                                                    <td className="manager">{hub?.amuMobile || ""}</td>
                                                    {
                                                        activeTab == "mapped" ?
                                                            <>
                                                                <td className="amu-agents">{hub?.isManager == true ? "YES" : "NO"}</td>
                                                                <td className="dealers">{hub?.addedOn || ""}</td>
                                                            </>
                                                            : ""}
                                                    <td className="amu-agents">{hub?.active == true ? "YES" : "NO"}</td>
                                                    <td>
                                                        <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={activeTab == "mapped" ? true : false}
                                                            onChange={() => handleSwitchChange(hub, activeTab == "mapped" ? true : false)} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
            </div>
        </>
    );
};

export default HubDashboard;


const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    margin: "auto",
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#13d61dff',
                ...theme.applyStyles('dark', {
                    backgroundColor: '#13d61dff',
                }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
        ...theme.applyStyles('dark', {
            backgroundColor: 'rgba(255,255,255,.35)',
        }),
    },
}));